export { STYLES } from './styles.js';

export const FACE_SVG = `<svg viewBox="0 0 100 120"
  fill="none" class="oa-face-svg">
  <ellipse cx="50" cy="55" rx="35" ry="45"
    stroke="currentColor" stroke-width="1.8"/>
  <ellipse cx="36" cy="45" rx="5" ry="3.5"
    fill="currentColor" class="oa-eye"/>
  <ellipse cx="64" cy="45" rx="5" ry="3.5"
    fill="currentColor" class="oa-eye"/>
  <line x1="50" y1="52" x2="48" y2="62"
    stroke="currentColor" stroke-width="1.5"
    stroke-linecap="round"/>
  <path d="M40 72 Q50 79 60 72"
    stroke="currentColor" stroke-width="1.5"
    stroke-linecap="round" fill="none"/>
</svg>`;

export const FACE_ICON_SVG = `<svg viewBox="0 0 100 120"
  fill="none" class="oa-face-icon-svg">
  <ellipse cx="50" cy="55" rx="35" ry="45"
    stroke="currentColor" stroke-width="2"/>
  <ellipse cx="36" cy="45" rx="5" ry="3.5"
    fill="currentColor" class="oa-eye"/>
  <ellipse cx="64" cy="45" rx="5" ry="3.5"
    fill="currentColor" class="oa-eye"/>
  <line x1="50" y1="52" x2="48" y2="62"
    stroke="currentColor" stroke-width="1.65"
    stroke-linecap="round"/>
  <path d="M40 72 Q50 79 60 72"
    stroke="currentColor" stroke-width="1.65"
    stroke-linecap="round" fill="none"/>
</svg>`;

export const FACE_GUIDE_SVG = `<svg viewBox="0 0 100 120"
  fill="none" class="oa-face-svg">
  <ellipse cx="50" cy="55" rx="35" ry="45"
    stroke="currentColor" stroke-width="1.8"
    stroke-dasharray="6 4"/>
  <ellipse cx="36" cy="45" rx="5" ry="3.5"
    fill="currentColor" class="oa-eye"/>
  <ellipse cx="64" cy="45" rx="5" ry="3.5"
    fill="currentColor" class="oa-eye"/>
  <line x1="50" y1="52" x2="48" y2="62"
    stroke="currentColor" stroke-width="1.5"
    stroke-linecap="round"/>
  <path d="M40 72 Q50 79 60 72"
    stroke="currentColor" stroke-width="1.5"
    stroke-linecap="round" fill="none"/>
</svg>`;

export const CHECK_SVG = `<svg viewBox="0 0 24 24"
  fill="none" stroke="currentColor" stroke-width="2.5"
  stroke-linecap="round" stroke-linejoin="round">
  <polyline points="20 6 9 17 4 12"/>
</svg>`;

export const CLOSE_SVG = `<svg viewBox="0 0 24 24"
  fill="none" stroke="currentColor" stroke-width="2"
  stroke-linecap="round">
  <line x1="18" y1="6" x2="6" y2="18"/>
  <line x1="6" y1="6" x2="18" y2="18"/>
</svg>`;

export const RETRY_SVG = `<svg viewBox="0 0 16 16"
  xmlns="http://www.w3.org/2000/svg"
  fill="currentColor">
  <path d="m14.955 7.986.116.01a1 1 0 0 1 .85 1.13 8 8 0 0 1-13.374 4.728l-.84.84c-.63.63-1.707.184-1.707-.707V10h3.987c.89 0 1.337 1.077.707 1.707l-.731.731a6 6 0 0 0 8.347-.264 6 6 0 0 0 1.63-3.33 1 1 0 0 1 1.131-.848zM11.514.813a8 8 0 0 1 1.942 1.336l.837-.837c.63-.63 1.707-.184 1.707.707V6h-3.981c-.89 0-1.337-1.077-.707-1.707l.728-.729a6 6 0 0 0-9.98 3.591 1 1 0 1 1-1.98-.281A8 8 0 0 1 11.514.813"/>
</svg>`;

export const SPINNER_SVG = `<svg viewBox="0 0 24 24"
  fill="none" stroke="currentColor" stroke-width="2.5">
  <circle cx="12" cy="12" r="10" opacity="0.2"/>
  <path d="M12 2 A10 10 0 0 1 22 12"
    stroke-linecap="round">
    <animateTransform attributeName="transform"
      type="rotate" from="0 12 12" to="360 12 12"
      dur="0.8s" repeatCount="indefinite"/>
  </path>
</svg>`;

export const SHIELD_SVG = `<svg viewBox="0 0 24 24"
  fill="none" stroke="currentColor" stroke-width="1.5">
  <path d="M12 2l8 4v6c0 5.5-3.8 10-8 12
    C7.8 22 4 17.5 4 12V6l8-4z"/>
  <path d="M9 12l2 2 4-4" stroke-width="2"
    stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;

export function resolveTheme(theme) {
    if (theme === 'light' || theme === 'dark') return theme;
    return resolveAutoTheme();
}

export function watchTheme(host, theme) {
    if (theme === 'light' || theme === 'dark') return;
    if (typeof window === 'undefined') return;

    const update = () => {
        host.setAttribute('data-theme', resolveAutoTheme());
    };

    const cleanups = [];

    for (const query of ['(prefers-color-scheme: dark)', '(prefers-color-scheme: light)']) {
        const cleanup = watchMediaQuery(query, update);
        if (cleanup) cleanups.push(cleanup);
    }

    if (typeof MutationObserver === 'function') {
        const observer = new MutationObserver(update);
        const options = {
            attributes: true,
            attributeFilter: ['class', 'data-theme', 'style'],
        };

        if (document.documentElement) {
            observer.observe(document.documentElement, options);
        }

        if (document.body) {
            observer.observe(document.body, options);
        }

        cleanups.push(() => observer.disconnect());
    }

    return () => {
        for (const cleanup of cleanups) {
            cleanup();
        }
    };
}

function resolveAutoTheme() {
    if (typeof window === 'undefined') return 'dark';

    const documentTheme = resolveDocumentTheme();
    if (documentTheme) return documentTheme;

    const systemTheme = resolveSystemTheme();
    if (systemTheme) return systemTheme;

    return 'dark';
}

function resolveSystemTheme() {
    if (typeof window.matchMedia !== 'function') {
        return null;
    }

    if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
        return 'dark';
    }

    if (window.matchMedia('(prefers-color-scheme: light)').matches) {
        return 'light';
    }

    return null;
}

function resolveDocumentTheme() {
    if (typeof document === 'undefined') return null;

    for (const element of [document.documentElement, document.body]) {
        const theme = readThemeHint(element);
        if (theme) return theme;
    }

    return null;
}

function readThemeHint(element) {
    if (!element || typeof window.getComputedStyle !== 'function') {
        return null;
    }

    const explicit = readExplicitTheme(element);
    if (explicit) return explicit;

    const styles = window.getComputedStyle(element);
    const scheme = parseColorScheme(styles.colorScheme);
    if (scheme) return scheme;

    return parseBackgroundTheme(styles.backgroundColor);
}

function readExplicitTheme(element) {
    const attrTheme = element.getAttribute('data-theme');
    if (attrTheme === 'light' || attrTheme === 'dark') {
        return attrTheme;
    }

    const className = element.className;
    if (typeof className !== 'string') return null;

    if (/\bdark\b|theme-dark|dark-theme/i.test(className)) {
        return 'dark';
    }

    if (/\blight\b|theme-light|light-theme/i.test(className)) {
        return 'light';
    }

    return null;
}

function parseColorScheme(value) {
    if (!value || value === 'normal') return null;

    const normalized = value.toLowerCase();
    const hasDark = normalized.includes('dark');
    const hasLight = normalized.includes('light');

    if (hasDark && !hasLight) return 'dark';
    if (hasLight && !hasDark) return 'light';

    return null;
}

function parseBackgroundTheme(value) {
    if (!value || value === 'transparent') return null;

    const match = value.match(/rgba?\(([^)]+)\)/i);
    if (!match) return null;

    const parts = match[1]
        .split(',')
        .slice(0, 3)
        .map((part) => Number.parseFloat(part.trim()));

    if (parts.length !== 3 || parts.some(Number.isNaN)) {
        return null;
    }

    const [red, green, blue] = parts;
    const brightness = (red * 299 + green * 587 + blue * 114) / 1000;

    if (brightness <= 140) return 'dark';
    if (brightness >= 180) return 'light';

    return null;
}

function watchMediaQuery(query, listener) {
    if (typeof window.matchMedia !== 'function') {
        return null;
    }

    const mediaQuery = window.matchMedia(query);

    if (typeof mediaQuery.addEventListener === 'function') {
        mediaQuery.addEventListener('change', listener);
        return () => {
            mediaQuery.removeEventListener('change', listener);
        };
    }

    if (typeof mediaQuery.addListener === 'function') {
        mediaQuery.addListener(listener);
        return () => {
            mediaQuery.removeListener(listener);
        };
    }

    return null;
}

export function checkboxTemplate(labelText) {
    return `
    <div class="oa-widget-wrap">
      <div class="oa-checkbox" role="checkbox"
        aria-checked="false" tabindex="0">
        <div class="oa-check-box"></div>
        <div class="oa-label">
          <span class="oa-label-text">${labelText}</span>
        </div>
        <div class="oa-right-section">
          <div class="oa-branding-row">
            <div class="oa-face-icon-wrap">
              ${FACE_ICON_SVG}
            </div>
            <a class="oa-branding-link"
              href="https://github.com/tn3w/OpenAge"
              target="_blank" rel="noopener">OpenAge</a>
          </div>
          <div class="oa-links-row">
            <a href="https://github.com/tn3w/OpenAge"
              target="_blank"
              rel="noopener">Terms</a>
            <a href="https://github.com/tn3w/OpenAge"
              target="_blank"
              rel="noopener">Privacy</a>
          </div>
        </div>
      </div>
      <div class="oa-error-slot"></div>
    </div>
  `;
}

export function heroTemplate(statusText) {
    return `
    <div class="oa-hero">
      <div class="oa-hero-icon">
        ${FACE_SVG.replace('class="oa-face-svg"', 'class="oa-face-svg oa-idle"')}
      </div>
      <p class="oa-hero-status">${statusText}</p>
      <p class="oa-hero-privacy">
        ${SHIELD_SVG}
        Open-source &amp; privacy-focused.
        No photos or camera data leave your device.
      </p>
    </div>
  `;
}

export function challengeTemplate() {
    return `
    <div class="oa-video-area">
      <video autoplay playsinline muted></video>
      <div class="oa-face-guide">
        ${FACE_GUIDE_SVG}
      </div>
      <div class="oa-challenge-hud oa-hidden">
        <p class="oa-challenge-text"></p>
        <div class="oa-challenge-bar">
          <div class="oa-challenge-fill"
            style="width:0%"></div>
        </div>
      </div>
      <div class="oa-video-status">
        <p></p>
      </div>
    </div>
  `;
}

export function errorStepTemplate(message) {
    return `
    <div class="oa-error-step">
      <div class="oa-error-step-icon">✕</div>
      <div class="oa-error-step-title">Verification stopped</div>
      <div class="oa-error-step-message">${message}</div>
      <div class="oa-error-step-countdown"></div>
    </div>
  `;
}

export function resultTemplate(outcome, message) {
    const icons = {
        pass: '✓',
        fail: '✕',
        retry: '↻',
    };
    const classes = {
        pass: 'oa-result-pass',
        fail: 'oa-result-fail',
        retry: 'oa-result-retry',
    };
    return `
    <div class="oa-result ${classes[outcome] || ''}">
      <div class="oa-result-icon">
        ${icons[outcome] || '?'}
      </div>
      <div class="oa-result-text">${message}</div>
    </div>
  `;
}

export function errorBannerTemplate(message) {
    return `
    <div class="oa-error-banner">
      <span>${message}</span>
      <button class="oa-retry-btn">Retry</button>
    </div>
  `;
}
